import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button,
  withMobileDialog,
  withStyles
} from "@material-ui/core";
import styles from "../wrappers/admin/Admin.Styles";
import PropTypes from "prop-types";

class ConfirmModal extends Component {
  render() {
    const { fullscreen, title, message, handleOk, handleCancel } = this.props;

    return (
      <Dialog
        fullscreen={fullscreen}
        open={true}
        onClose={this.handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
        <DialogContent>{message}</DialogContent>
        <DialogActions>
          <Button onClick={handleOk} color="primary">
            Ok
          </Button>
          <Button onClick={handleCancel} color="primary" autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ConfirmModal.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  handleOk: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired
};

export default connect(state => state)(
  withStyles(styles)(withMobileDialog()(ConfirmModal))
);
